import { ReactNode } from 'react';
import { CardHeightWrapper } from './CardHeightWrapper';

/** Absolutely-positioned semi-transparent overlay for tables, used to display a loading/status state over existing content. */
export const TableOverlay = ({ children }: { children: ReactNode }) => (
  <div className="bg-canvas-tertiary-main bg-opacity-[0.85] absolute top-0 left-0 h-full w-full z-20">
    <CardHeightWrapper>{children}</CardHeightWrapper>
  </div>
);
